import { useState } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('name', formData.name);
      formBody.append('email', formData.email);
      formBody.append('phone', formData.phone);
      formBody.append('message', formData.message);

      const response = await fetch('https://readdy.ai/api/public/form/submit/monceau-contact-form', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', phone: '', message: '' });
        setTimeout(() => setSubmitStatus('idle'), 5000);
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const stores = [
    {
      name: 'MONCEAU FLEURS 新光三越台北南西店',
      phone: '02-2541-9859',
      address: '10491臺北市中山區南京西路12號B2',
      hours: '11:00–21:30',
      mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3614.4982!2d121.5203!3d25.0522!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjXCsDAzJzA4LjAiTiAxMjHCsDMxJzEzLjEiRQ!5e0!3m2!1szh-TW!2stw!4v1234567890'
    },
    {
      name: 'Monceau Fleurs 南港店',
      phone: '02-2654-7976',
      address: '115臺北市南港區經貿二路131號1樓',
      hours: '11:00–21:30',
      mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3615.2!2d121.6075!3d25.0585!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjXCsDAzJzMwLjYiTiAxMjHCsDM2JzI3LjAiRQ!5e0!3m2!1szh-TW!2stw!4v1234567890'
    }
  ];

  return (
    <section id="contact" className="py-16 sm:py-20 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#2C2C2C] mb-3 sm:mb-4">
            聯繫我們
          </h2>
          <p className="text-sm sm:text-base text-gray-600 max-w-2xl mx-auto px-4">
            有任何花藝需求或問題，歡迎隨時與我們聯繫
          </p>
        </div>

        {/* 店鋪地圖與資訊 */}
        <div className="mb-16 sm:mb-20">
          <h3 className="text-2xl sm:text-3xl font-bold text-[#2C2C2C] mb-8 sm:mb-10 text-center">
            門市據點
          </h3>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-10">
            {stores.map((store, index) => (
              <div key={index} className="bg-[#FAFAFA] rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-shadow">
                {/* 地圖 */}
                <div className="w-full h-64 sm:h-80">
                  <iframe
                    src={store.mapUrl}
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title={store.name}
                  ></iframe>
                </div>
                
                {/* 店鋪資訊 */}
                <div className="p-6 sm:p-8">
                  <h4 className="text-lg sm:text-xl font-bold text-[#2C2C2C] mb-4">
                    {store.name}
                  </h4>
                  
                  <div className="space-y-3">
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex items-center justify-center bg-[#14B8A6] rounded-lg flex-shrink-0">
                        <i className="ri-map-pin-line text-lg text-white"></i>
                      </div>
                      <div>
                        <div className="text-xs text-gray-500 mb-1">地址</div>
                        <div className="text-sm sm:text-base text-[#2C2C2C]">{store.address}</div>
                      </div>
                    </div>

                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex items-center justify-center bg-[#14B8A6] rounded-lg flex-shrink-0">
                        <i className="ri-phone-line text-lg text-white"></i>
                      </div>
                      <div>
                        <div className="text-xs text-gray-500 mb-1">電話</div>
                        <a href={`tel:${store.phone.replace(/-/g, '')}`} className="text-sm sm:text-base text-[#2C2C2C] hover:text-[#14B8A6] transition-colors cursor-pointer">
                          {store.phone}
                        </a>
                      </div>
                    </div>

                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex items-center justify-center bg-[#14B8A6] rounded-lg flex-shrink-0">
                        <i className="ri-time-line text-lg text-white"></i>
                      </div>
                      <div>
                        <div className="text-xs text-gray-500 mb-1">營業時間</div>
                        <div className="text-sm sm:text-base text-[#2C2C2C] font-semibold">{store.hours}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 sm:gap-12">
          <div>
            <div className="bg-[#FAFAFA] rounded-2xl p-6 sm:p-8 mb-6 sm:mb-8">
              <h3 className="text-xl sm:text-2xl font-bold text-[#2C2C2C] mb-5 sm:mb-6">
                聯絡資訊
              </h3>

              <div className="space-y-5 sm:space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-11 h-11 sm:w-12 sm:h-12 flex items-center justify-center bg-[#14B8A6] rounded-xl flex-shrink-0">
                    <i className="ri-user-line text-xl sm:text-2xl text-white"></i>
                  </div>
                  <div>
                    <div className="text-xs sm:text-sm text-gray-500 mb-1">聯絡人</div>
                    <div className="text-base sm:text-lg font-semibold text-[#2C2C2C]">賴柏臻</div>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-11 h-11 sm:w-12 sm:h-12 flex items-center justify-center bg-[#14B8A6] rounded-xl flex-shrink-0">
                    <i className="ri-phone-line text-xl sm:text-2xl text-white"></i>
                  </div>
                  <div>
                    <div className="text-xs sm:text-sm text-gray-500 mb-1">電話</div>
                    <a href="tel:0916333313" className="text-base sm:text-lg font-semibold text-[#2C2C2C] hover:text-[#14B8A6] transition-colors cursor-pointer">
                      0916-333-313
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-11 h-11 sm:w-12 sm:h-12 flex items-center justify-center bg-[#14B8A6] rounded-xl flex-shrink-0">
                    <i className="ri-mail-line text-xl sm:text-2xl text-white"></i>
                  </div>
                  <div>
                    <div className="text-xs sm:text-sm text-gray-500 mb-1">電子郵件</div>
                    <a href="mailto:raberlai@gmail.com" className="text-base sm:text-lg font-semibold text-[#2C2C2C] hover:text-[#14B8A6] transition-colors break-all cursor-pointer">
                      raberlai@gmail.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-11 h-11 sm:w-12 sm:h-12 flex items-center justify-center bg-[#14B8A6] rounded-xl flex-shrink-0">
                    <i className="ri-building-line text-xl sm:text-2xl text-white"></i>
                  </div>
                  <div>
                    <div className="text-xs sm:text-sm text-gray-500 mb-1">公司名稱</div>
                    <div className="text-base sm:text-lg font-semibold text-[#2C2C2C]">羽天國際股份有限公司</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-[#14B8A6] to-[#0F9B8E] rounded-2xl p-6 sm:p-8 text-white">
              <h3 className="text-xl sm:text-2xl font-bold mb-3 sm:mb-4">客服時間</h3>
              <div className="space-y-2 sm:space-y-3 text-sm sm:text-base">
                <div className="flex justify-between">
                  <span>週一至週五</span>
                  <span className="font-semibold">09:00 - 18:00</span>
                </div>
                <div className="flex justify-between">
                  <span>週六</span>
                  <span className="font-semibold">10:00 - 17:00</span>
                </div>
                <div className="flex justify-between">
                  <span>週日</span>
                  <span className="font-semibold">公休</span>
                </div>
              </div>
              <div className="mt-4 pt-4 border-t border-white/20">
                <p className="text-xs opacity-90">
                  * 門市營業時間請參考各店鋪資訊
                </p>
              </div>
            </div>
          </div>

          <div className="bg-[#FAFAFA] rounded-2xl p-6 sm:p-8">
            <h3 className="text-xl sm:text-2xl font-bold text-[#2C2C2C] mb-5 sm:mb-6">
              發送訊息
            </h3>

            <form id="monceau-contact-form" onSubmit={handleSubmit} data-readdy-form className="space-y-4 sm:space-y-5">
              <div>
                <label htmlFor="name" className="block text-sm font-semibold text-[#2C2C2C] mb-2">
                  姓名 *
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-2.5 sm:py-3 text-sm sm:text-base border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#14B8A6] focus:border-transparent transition-all"
                  placeholder="請輸入您的姓名"
                />
              </div>

              <div>
                <label htmlFor="email" className="block text-sm font-semibold text-[#2C2C2C] mb-2">
                  電子郵件 *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-2.5 sm:py-3 text-sm sm:text-base border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#14B8A6] focus:border-transparent transition-all"
                  placeholder="請輸入您的電子郵件"
                />
              </div>

              <div>
                <label htmlFor="phone" className="block text-sm font-semibold text-[#2C2C2C] mb-2">
                  電話
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full px-4 py-2.5 sm:py-3 text-sm sm:text-base border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#14B8A6] focus:border-transparent transition-all"
                  placeholder="請輸入您的電話"
                />
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-semibold text-[#2C2C2C] mb-2">
                  訊息 *
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  maxLength={500}
                  rows={5}
                  className="w-full px-4 py-2.5 sm:py-3 text-sm sm:text-base border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#14B8A6] focus:border-transparent transition-all resize-none"
                  placeholder="請輸入您的訊息（最多500字）"
                ></textarea>
                <div className="text-xs text-gray-500 mt-1.5">
                  {formData.message.length}/500
                </div>
              </div>

              {submitStatus === 'success' && (
                <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-xl text-sm">
                  訊息已成功發送！我們會盡快與您聯繫。
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-xl text-sm">
                  發送失敗，請稍後再試或直接撥打電話聯繫我們。
                </div>
              )}

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-[#14B8A6] text-white py-3 sm:py-4 rounded-xl font-semibold text-sm sm:text-base hover:bg-[#0F9B8E] transition-colors duration-300 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
              >
                {isSubmitting ? '發送中...' : '發送訊息'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
